(function () {
  var btn = document.querySelector('[data-back-to-top]');
  if (!btn || btn._bttInit) return;
  btn._bttInit = true;

  var lastY = window.scrollY || 0;
  var ticking = false;
  var stopTimer = null;
  var visible = false;
  var SHOW_DELAY_MS = 1000;

  function foldThreshold() {
    return window.innerHeight || 600;
  }

  function setVisible(show) {
    if (show === visible) return;
    visible = show;
    btn.classList.toggle('is-visible', show);
    btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  }

  function scheduleShowAfterStop() {
    clearTimeout(stopTimer);
    stopTimer = setTimeout(function () {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      if (y > foldThreshold()) {
        setVisible(true);
      }
    }, SHOW_DELAY_MS);
  }

  function evaluate() {
    var y = window.scrollY || document.documentElement.scrollTop || 0;

    if (y <= foldThreshold()) {
      clearTimeout(stopTimer);
      setVisible(false);
    }

    lastY = y;
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(evaluate);
      ticking = true;
    }

    var y = window.scrollY || document.documentElement.scrollTop || 0;
    if (y <= foldThreshold()) return;

    setVisible(false);
    scheduleShowAfterStop();
  }

  btn.addEventListener('click', function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  evaluate();
})();
